import MedicalCommission from "assets/menu-icons/MedicalCommission";

const medicalCommission = {
  id: 'medicalCommission',
  type: 'group',
  restricted: true,
  // пункт «ВЭК» показываем только если у пациента есть карты профосмотра (hasVek / HAS_VEK)
  requiresVek: true,
  children: [{
    id: 'medicalCommission',
    title: 'ВЭК',
    type: 'item',
    url: '/medicalCommission',
    icon: MedicalCommission,
    breadcrumbs: false,
    restricted: true,
  }]
}

export default medicalCommission;
